import {
  IPhotoDataManager,
  IClusterMetadataParams,
  IClustersdataParams,
  ISingleClusterParams,
  IFavoriteParams,
  IBulkDownloadParams,
  IUpdateAssetInfoParams,
  IUpdateBulkAssetPayLoadParams,
  IUpdateBulkUAAssetParams,
  IUpdateBulkAGAssetParams,
  IRemoveSinglePictParams,
  IClusterConfig,
  ILimittedAssetsParams,
  ImageEditParams
} from "./iphoto_data_manager";
import { AjaxHelper } from "../../http/ajax_helper";
import { IClientConfig } from "../data_manager/data_manager_factory";
import { Util } from "../../common_utils/util";
import { ITranslator } from "../translators/itranslator";
import { PhotoClusterHelper } from "./photo_cluster_helper";
//import * as $ from 'jquery';
import { IPhoto } from "../data_models/iphoto";

/**
 * This class is to interact with UserAssets endpoints of photo/photos opeartions,
 * It can be a single/list/cluster of photos
 * @export
 * @class UAPhotoManager
 * @implements {IPhotoDataManager}
 */
export class UAPhotoManager implements IPhotoDataManager {
  private translator: ITranslator;
  private discoveryEndPoints: any;
  clusterHelper: PhotoClusterHelper;
  constructor(config: IClientConfig) {
    this.translator = Util.getTranslatorObj(config);
    this.discoveryEndPoints = config.discoveryEndPoints;
    this.clusterHelper  = new PhotoClusterHelper();
  }

  /**
   * This methods is to get the photo cluster meta data information and first page response
   * @param {IClusterMetadataParams} clusterConfig
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  getClusterMetadata(clusterConfig: IClusterConfig): Promise<any> {
    clusterConfig = this.clusterHelper.clusterConfig = $.extend(true, this.clusterHelper.clusterConfig, clusterConfig);
    const clusterMetaQuerySring = `limit=0&minAsset=0&sortCriteria=${clusterConfig.sortCriteria}&timezoneOffset=${clusterConfig.timezoneOffset}`;
    const clusterMetaUrl = "asset/dateIndex?" + clusterMetaQuerySring;
    const metaPromise =  AjaxHelper.triggerApi({
      requestConfig: {
        url : this.discoveryEndPoints.pictApiService + clusterMetaUrl,
        type: "GET",
      }
    });
    let projection = "&projection=createDate,dateTaken,assetType,files,faces,ownerAccountId,parentCollectionReferences,userTags,subType"
    const clustersQuerySring = `skip=0&limit=${clusterConfig.clustersPerPage}&minAsset=${clusterConfig.minAssetPerCluster}&sortCriteria=${clusterConfig.sortCriteria}&timezoneOffset=${clusterConfig.timezoneOffset}${projection}`;
    const clustersUrl = "asset/dateIndex?" + clustersQuerySring;
    const firstpageResPromise =  AjaxHelper.triggerApi({
      requestConfig: {
        url: this.discoveryEndPoints.pictApiService + clustersUrl,
        type: "GET",
      }
    });
    let promise = Promise.all([metaPromise, firstpageResPromise]).then(values => { 
      let data = [values[0].data, values[1].data];
      return this.translator.preparePagesData(this.clusterHelper, data)
    });
    return promise;
  }

  /**
   * This method is to get list of cluster of perticular page and first set Url of cluster assets
   * And converts idividual photo repsonse of each cluster to a Iphoto custom format, with out disturbing the repsonse 
   * structure of the API response.
   * @param {string} pageUrl
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  getClusters(pageUrl: string): Promise<any> {
    const url = "asset/dateIndex?" + pageUrl;
    let config = {
      url: this.discoveryEndPoints.pictApiService + url,
      type: "GET",
    }
    const promise =  AjaxHelper.triggerApi(
      {requestConfig: config}, this.translator.translateClusters.bind(this.translator, this.clusterHelper))
    return promise;
  }
  
  /**
   * This method is to get the photos of a individual photo cluster and nexturl to get next set of assets of the cluster
   * @param {ISingleClusterParams} params
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  getClusterAssets(params: ISingleClusterParams): Promise<any> {
   params = this.getNextAssetsUrl(params);
    const url = "asset/dateIndex/cluster/" + params.date + "?" + params.nextUrl;
    params.nextUrl = url;
    let config = {
      url: this.discoveryEndPoints.pictApiService + url,
      type: "GET",
    }
    const promise =  AjaxHelper.triggerApi({requestConfig: config}, this.translator.translateClusterAssets.bind(this.translator, params, this.clusterHelper));   
    return promise;
  }

  /**
   * This method useful for edit save as scenario, where we need assets between a perticular range
   * @param {ILimittedAssetsParams} params
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  getLimittedAssets(params: ILimittedAssetsParams){
    let projection = "createDate,dateTaken,assetType,files,faces,ownerAccountId,parentCollectionReferences,userTags,subType"
    let relativeUrl = `skip=${params.updatedSkip}&limit=${params.updatedLimit}&date=${params.sortCriteria}&timezoneOffset=${this.clusterHelper.clusterConfig.timezoneOffset}&projection=${projection}`;
    return this.getClusterAssets({
      date: params.date,
      nextUrl: relativeUrl,
    })
  }

  //Upadtes the given parasm with updatedSkip and UpdatedLimit
  getNextAssetsUrl(params: ISingleClusterParams) {
    let updatedSkip = (typeof (params.updatedSkip) !== "undefined");
    let updatedLimit = (typeof (params.updatedLimit) !== "undefined");
    if (updatedSkip || updatedLimit) {
        let queryParams = new URLSearchParams(params.nextUrl);
        let skip = updatedSkip ? params.updatedSkip : queryParams.get('skip');
        let limit = updatedLimit ? params.updatedLimit : queryParams.get('limit');
        params.nextUrl = `limit=${limit}&skip=${skip}&date=${queryParams.get('date')}&timezoneOffset=${queryParams.get('timezoneOffset')}`;            
    }
    return params;
  }

  /**
   * Method to download photo(s) to local machine
   * @param {{ assetModels: string[], zipFileName: string }} data
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  getBulkDownloadHash(data: IBulkDownloadParams): Promise<any> {
    let url = this.discoveryEndPoints.pictApiService + 'asset/multiPhotoDownload';
    //add the bundleNumber of the zip file only if it is present. For single image download it is not present.
    url += data.bundleNumber ? '?index='+data.bundleNumber : "";
    let payload = this.translator.preparePayloadForDownload(data);
    const promise =  AjaxHelper.triggerApi({requestConfig: { url, type: 'POST', data: JSON.stringify(payload) }})
    return promise;
  }

  /**
   * Method to update one or more attribute of a single photo
   * @param {{ id: number, version: number, dateTaken: number }} data
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  updateAssetInfo(data: IUpdateAssetInfoParams): Promise<any> {
    const url = 'asset';
    let config = {
      url: this.discoveryEndPoints.pictApiService + url,
      type: "POST",
      data: JSON.stringify(data),
    }
    const promise =  AjaxHelper.triggerApi({requestConfig: config}, this.translator.translateUpdatedAsset.bind(this.translator));
    return promise;
  }

  /**
   * Method to update one or more attribute of a multiple photos
   * @param {[{ id: number, name: "xyz", dataTaken: 12662525}]}
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  //{"assetList" : [{"assetId":11174854666070, "name": "updatedCaption"}]}
  updateBulkAsset(data: IUpdateBulkAssetPayLoadParams): Promise<any> {    

    const url = 'asset/bulk';
    const tranlatedPayload: Array<IUpdateBulkUAAssetParams> = this.translator.translateAssetBulkAPIPayLoad(data);
    let config = {
      url: this.discoveryEndPoints.pictApiService + url,
      type: "PUT",
      data: JSON.stringify(tranlatedPayload),
    }
    const promise = AjaxHelper.triggerApi({requestConfig:  config }, this.translator.translateAssetBulkApiUAResponse.bind(this.translator));
    return promise;
  }

  /**
   * method to delete a single photo form a album/colletion
   *
   * @param {{ pictId: number, albumId: string }} data
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  removeSinglePictFromCollection(data: IRemoveSinglePictParams): Promise<any> {
    const url = 'collection/' + data.albumId + '/asset/' + data.pictId;
    let config = {
      url: this.discoveryEndPoints.pictApiService + url,
      type: "DELETE",
    }
    const promise = AjaxHelper.triggerApi({ requestConfig: config });
    return promise;
  }



  /**
   * Method to delete multiple photos can be form same album or different album
   * @param {number} data
   * @param {boolean} isMultipleAssets
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  deleteMultiplePicts(data: number, isMultipleAssets: boolean): Promise<any> {
    let url = "asset/multipleAssets";  //deleteMultipleAssets is not being used now
    let config = {
      url: this.discoveryEndPoints.pictApiService + url,
      type: "DELETE",
      data: JSON.stringify(data),
    }
    const promise = AjaxHelper.triggerApi({ requestConfig: config });
    return promise;
  }
 

  getFullAssetData(model: object): any {
    return model;
  }

  /**
   * Method to edit a perticular image.
   * As per common implemenatation format, we are expecting photoJson as param and never using this photo json.
   * We are translating the response photo json and returning to the client.
   * @param {ImageEditParams} reqConfig
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  editImage(reqConfig: ImageEditParams, photoJson: IPhoto): Promise<any> {
    let url = "asset/" + reqConfig.id + "/multiimageedit/" + reqConfig.editMode;

    let payload:any = {journals : reqConfig.journal, defaultSizes : reqConfig.defaultSize};

    if(reqConfig.editMode == "saveas" && reqConfig.albumId){
      url = "asset/" + reqConfig.id + "/multiedit/" + reqConfig.editMode + "?collectionId="+ reqConfig.albumId;
      payload = {journal: reqConfig.journal, defaultSize : reqConfig.defaultSize};
    }

    let config = {
      url: this.discoveryEndPoints.pictApiService + url,
      type: "POST",
      data: JSON.stringify(payload),
    }
    const promise = AjaxHelper.triggerApi({ requestConfig: config},this.translator.trnaslateUAEditedPhoto.bind(this.translator));    
    return promise;
  }

  /**
   * Method to make a perticular photo as favourite
   * @param {IFavoriteParams} reqConfig
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  favoritePhoto(reqConfig: IFavoriteParams): Promise<any> {
    const url = "asset/" + reqConfig.assetId + "/favorite?favorite=" + reqConfig.isFavorite;
    let config = {
      url: this.discoveryEndPoints.pictApiService + url,
      type: "POST",
    }
    const promise = AjaxHelper.triggerApi({ requestConfig: config});    
    return promise;
  }

  /**
   * Used to delete for given picture Id.
   *
   * @param {number} pictId
   * @returns {Promise<any>}
   * @memberof UAPhotoManager
   */
  deleteSinglePict(pictId: number): Promise<any> {
    const url = 'asset/' + pictId;
    let config = {
      url: this.discoveryEndPoints.pictApiService + url,
      type: "DELETE",
    }
    const promise = AjaxHelper.triggerApi({ requestConfig: config});
    return promise;
  }
  /* istanbul ignore next */
  updateFavoriteImageIds(imageId: string,addAsFavorite: boolean){
    //Dummy method to avoid condition at client end.
  }
 
}


